import { applyDefaultTheme } from '@app/utils/theme'
import { getPublicConfig } from '@app/shared/config'
import { colorLog } from '@app/utils/html'
import { initializeOkta, login } from '@app/shared/auth'
import { loadFeatureFlags } from '@app/shared/feature-flags'
import { loadSettings } from '@app/shared/settings'
import { loadWordReplacementDictionary } from '@app/services/word-replacement.service'
import { startInactivityDetection, startMaxSessionDetection } from '@app/utils/session'

try {
  // Set up theme
  applyDefaultTheme('light')

  // Load public config
  const config = await getPublicConfig(true)
  colorLog('Config loaded')

  // Initilize Okta
  await initializeOkta(config.ssoSettings)

  // Login
  const status = await login()
  if (status) {
    colorLog('Login success')
    // start max session detection
    startMaxSessionDetection()
    // start session inactivity detection
    startInactivityDetection()
    // Load app root
    await Promise.allSettled([
      await loadSettings(),
      await loadFeatureFlags(),
      await loadWordReplacementDictionary(),
      import('@app/app-root.component'),
      customElements.whenDefined('app-root'),
    ])
    colorLog('Application loaded')
  }

  // wake up detection
  const sleepWorker = new Worker('/sleep-worker.js', { type: 'module' })
  sleepWorker.onmessage = (e) => {
    if (e.data === 'computer-wakeup') {
      console.log(`The computer likely went to sleep and woke up later.`)
      startMaxSessionDetection()
    }
  }
} catch (error) {
  console.error(error)
  colorLog('Application failed to load', { color: 'red' })
} finally {
  // remove body loading state
  document.querySelector('body')?.classList.remove('initializing')
  document.querySelector('.initializing-loader')?.remove()
}
